export default "__VITE_ASSET__b99d7912__"